import React, { useEffect } from "react";
import styled from "styled-components";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Sprig from "./Sprig";

export default function Page({ title, subtitle, children, narrow }) {
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [title]);
  return (
    <>
      <Navbar />
      <Wrap $narrow={narrow}>
        <Head>
          <Sprig width={40} color="#C9B68E" style={{ display: "block", margin: "0 auto 20px" }} />
          <h1>{title}</h1>
          {subtitle && <p className="sub">{subtitle}</p>}
        </Head>
        <Body>{children}</Body>
      </Wrap>
      <Footer />
    </>
  );
}

const Wrap = styled.div`
  max-width: ${({ $narrow }) => ($narrow ? "640px" : "820px")};
  margin: 0 auto;
  padding: clamp(40px, 7vw, 80px) clamp(20px, 5vw, 40px) 70px;
`;

const Head = styled.div`
  text-align: center;
  margin-bottom: clamp(36px, 6vw, 56px);
  h1 {
    font-family: ${({ theme }) => theme.font.display};
    font-weight: 500;
    font-size: clamp(32px, 6vw, 52px);
    color: ${({ theme }) => theme.colors.ink};
  }
  .sub { margin: 14px auto 0; max-width: 520px; color: ${({ theme }) => theme.colors.inkSoft}; font-size: 17px; }
`;

const Body = styled.div`
  h2 {
    font-family: ${({ theme }) => theme.font.display};
    font-weight: 500;
    font-size: clamp(20px, 3vw, 26px);
    color: ${({ theme }) => theme.colors.green};
    margin: 32px 0 12px;
  }
  h2:first-child { margin-top: 0; }
  p, li { color: ${({ theme }) => theme.colors.ink}; font-size: 15.5px; line-height: 1.7; }
  p { margin-bottom: 14px; }
  ul { padding-left: 20px; margin-bottom: 14px; display: flex; flex-direction: column; gap: 7px; }
  li { list-style: disc; }
  a { color: ${({ theme }) => theme.colors.green}; text-decoration: underline; }
  strong { font-weight: 600; }
  .updated { color: ${({ theme }) => theme.colors.inkSoft}; font-size: 13.5px; margin-bottom: 24px; }
`;
